module.exports = __webpack_public_path__ + "static/img/meizuPro6Plus.09afd4d4.jpg";